export default "__VITE_ASSET__KfkaySBy__"